module.exports = __webpack_public_path__ + "img/Paso 2.5ce15529.png";